import React, { useState } from "react";
import cx from "classnames";
import PropTypes from "prop-types";

import global from "../../../scss/dhp.scss";

import AssetName from "./Common/AssetName";
import AssetSearch from "./Common/AssetSearch";
import AssetCategory from "./Common/AssetCategory";
import AssetLists from "./Common/AssetLists";

let style = Object.assign({}, global);

const Sticker = props => {
  const [keyword, setKeyword] = useState("");
  const [category, setCategory] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [isAssetFetched, setIsAssetFetched] = useState(false);
  const [availableAssetCategories, setAvailableAssetCategories] = useState([]);
  const [asstesLoading, setAsstesLoading] = useState();

  return (
    <div className={cx(style["editor-asset-inner"], style["sticker-asset"])}>
      <AssetName handleWidgetAction={props.handleWidgetAction} assetName={props.assetName} />

      <div className={style["pe-20"]}>
        <AssetSearch
          assetName={props.assetName}
          setKeyword={setKeyword}
          setCategory={setCategory}
          setPageNumber={setPageNumber}
          setIsAssetFetched={setIsAssetFetched}
          keyword={keyword}
        />

        <AssetCategory
          category={category}
          setCategory={setCategory}
          setKeyword={setKeyword}
          setPageNumber={setPageNumber}
          setIsAssetFetched={setIsAssetFetched}
          availableAssetCategories={availableAssetCategories}
          asstesLoading={asstesLoading}
        />
      </div>

      <AssetLists
        assetName={props.assetName}
        assetType={props.assetType}
        keyword={keyword}
        assetCategory={category}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        isAssetFetched={isAssetFetched}
        setIsAssetFetched={setIsAssetFetched}
        setAvailableAssetCategories={setAvailableAssetCategories}
        asstesLoading={asstesLoading}
        setAsstesLoading={setAsstesLoading}
      />
    </div>
  );
};

//Props type validation
Sticker.propTypes = {
  handleWidgetAction: PropTypes.func.isRequired,
  assetName: PropTypes.string.isRequired,
  assetType: PropTypes.string.isRequired,
};
export default Sticker;
